import { render, staticRenderFns } from "./PatientMedicationFiltersRep.vue?vue&type=template&id=4b8e5a3b&"
import script from "./PatientMedicationFiltersRep.vue?vue&type=script&lang=js&"
export * from "./PatientMedicationFiltersRep.vue?vue&type=script&lang=js&"
import style0 from "./PatientMedicationFiltersRep.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports